import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, withRouter, Redirect } from 'react-router-dom';

import './App.css';
import './sp-frame.css';
import './mobile-frame.css';
import './home.css';

import store from '../store';

import Home from './home/Home';
import SearchV2 from './v2/search/index';
import Search from "./search/Search"
import Coverage from './coverage/Coverage';
import Purchase from './purchase/Purchase';
import Comparison from './comparison/Comparison';
import PurchaseStatus from './purchase_status/PurchaseStatus';
import Header from '../components/header/Header';

import { getUrlParams } from '../utils';
import {
  getCouponData,
  fetchProvidersService,
  fetchDestinationsService,
  fetchPaymentMethodsService,
} from '../apiCalls';
import { getDestinations, globalProviderSettings } from '../actions/globalActions';
import manageParams from '../parameterManager';
import {
  setPartner,
  fetchUserDetails,
  getInfosProspect,
  getBenefits,
  getPaymentMethodsAvaliable,
} from '../actions/purchaseActions';
import { mobileActive } from '../actions/mobileActions';
import { page404, page500 } from './error_pages/ErrorPages';
import { GrowthBook } from '@growthbook/growthbook-react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import matomoTracker from '../utils/matomo';

const applyCoupon = (WrappedComponent) =>
  class extends Component {
    constructor(props) {
      super(props);

      if (!window.location.pathname.includes('pedido'))
        getCouponData(getUrlParams().cupom, '', this.props.match.params.begin_date, this.props.match.params.end_date);
    }

    render() {
      return (
        <React.Fragment>
          <WrappedComponent {...this.props} />
        </React.Fragment>
      );
    }
  };

const growthbook = new GrowthBook({
  apiHost: process.env.REACT_APP_GROWTHBOOK_API_HOST,
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    const experimentId = experiment.key;
    const variationId = result.variationId;

    matomoTracker.trackEvent('Experiment', 'Viewed', experimentId, variationId);

    console.log("Experiment viewed:", {
      experiment,
      result
    });
  },
});

window._paq = window._paq || [];
window._paq.push([function () {
  try {
    matomoTracker.getMatomoVisitorId().then((matomoVisitorId) => {
      growthbook.setAttributes({
        id: matomoVisitorId
      });
      growthbook.init({ streaming: true }).then(() => {
        matomoTracker.setGrowthbookInstance(growthbook);
      });
    });
  } catch (e) {
    console.error("Erro ao definir o ID do visitante no GrowthBook:", e);
  }
}]);


export const dataIsValid = () => {
  const url = new URL(window.location.href);
  const newParams = url.pathname.split('/').filter((t) => t !== '');

  let todayDate = new Date();
  todayDate = new Date(`${todayDate.getFullYear()}-${todayDate.getMonth() + 1}-${todayDate.getDate()} 00:00`);

  const begin_date = new Date(`${newParams[newParams.length - 2]} 00:00:00`);
  const end_date = new Date(`${newParams[newParams.length - 1]} 00:00:00`);

  if (begin_date < todayDate || end_date < todayDate) {
    return false;
  }

  return true;
};

class Routes extends Component {
  componentWillMount() {
    this.setPartner();

    fetchDestinationsService().then((response) => {
      store.dispatch(getDestinations(response.destinations));
    });

    fetchProvidersService().then((response) => {
      store.dispatch(globalProviderSettings(response.providers));
    });

    store.dispatch(fetchUserDetails());

    // runGoogleAnalytics();
    manageParams();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      window.scrollTo(0, 0);

      // runGoogleAnalytics();
      manageParams();
    }
  }

  componentDidMount() {
    store.dispatch(getInfosProspect());
    store.dispatch(getBenefits());
    fetchPaymentMethodsService().then((response) => {
      store.dispatch(getPaymentMethodsAvaliable(response.payment_methods));
    });
  }

  setPartner() {
    if (this.props.match.params.partner) {
      store.dispatch(setPartner(this.props.match.params.partner));
    }
  }

  render() {
    if (dataIsValid()) {
      return (
        <React.Fragment>
          <Switch>
            <Route
              path={
                this.props.match.path +
                `/pesquisa/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/`
              }
              component={withRouter(applyCoupon(SearchV2))}
            />
            <Route
              path={
                this.props.match.path +
                `/seguro-viagem/comparacao/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/`
              }
              component={withRouter(applyCoupon(Comparison))}
            />
            <Route
              path={
                this.props.match.path +
                `/seguro-viagem/cobertura/:product_code/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/`
              }
              component={withRouter(applyCoupon(Coverage))}
            />
            <Route
              path={
                this.props.match.path +
                `/pedido/:product_code(\\d+)/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/`
              }
              component={withRouter(applyCoupon(Purchase))}
            />
            <Route path={this.props.match.path + `/pedido-finalizado/:uuid/status`} component={PurchaseStatus} />
            <Route exact path={this.props.match.path} component={Home} />
            <Route path="/" component={page404} />
          </Switch>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Redirect exact to={this.props.match.path} component={Home} />
      </React.Fragment>
    );
  }
}

class App extends Component {
  componentDidMount() {
    matomoTracker.trackPageView(document.title);
    window.addEventListener('resize', () => {
      store.dispatch(mobileActive());
    });
  }

  componentDidUpdate(prevProps) {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    growthbook.destroy();
  }

  handleResize = () => {
    store.dispatch(mobileActive());
  };

  render() {
    return (
      <GrowthBookProvider growthbook={growthbook}>
        <Provider key={2} store={store}>
          <div className="App">
            <Router>
              <React.Fragment>
                <Header />
                <Switch>
                  <Route path={process.env.REACT_APP_PATH} component={Routes} />
                  <Route path="/p/:partner" component={Routes} />
                  <Route exact path="/" component={Home} />
                  <Route path="/" component={page404} />
                  <Route path="/500/" component={page500} />
                </Switch>
              </React.Fragment>
            </Router>
          </div>
        </Provider>
      </GrowthBookProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/views/App.js